import { createRouter, createWebHistory } from "vue-router";
import { ReviseMeta } from "@/util/meta";
import { deviceType } from "@/util/base";

// 定义广告平台及版本映射
const adRoutesVersions = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "B2",
  "C2",
  "D2",
];

// 特殊映射
const adRoutesComponentMap = { L: "A", M: "M" };

// 定义平台
const platforms = [
  {
    prefix: "TT",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // 抖音
  {
    prefix: "FB",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // 脸书
  {
    prefix: "GG",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // 谷歌
  {
    prefix: "tw",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // 推特
  {
    prefix: "TW",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // 推特
  {
    prefix: "Zucksad",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // Zucksad渠道
  {
    prefix: "Zucks",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // Zucks渠道
  {
    prefix: "AMoAd",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // AMoAd渠道
  {
    prefix: "SeedApp",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // SeedApp渠道
  {
    prefix: "imobile",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // imobile渠道
  {
    prefix: "SKYFLAG",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // SKYFLAG渠道
  {
    prefix: "Smartnews",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // Smartnews渠道
  {
    prefix: "line",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // line渠道
  {
    prefix: "unicorn",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // unicorn渠道

  {
    prefix: "Fukurou",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, //Fukurou渠道
  {
    prefix: "inmobi",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // inmobi渠道
  {
    prefix: "moloco",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // moloco渠道
  {
    prefix: "presco",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // presco渠道
  {
    prefix: "appier",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // appier渠道
];

// 使用 import.meta.glob 导入所有组件
const downComponents = import.meta.glob("./views/down/*.vue");
// const shopComponents = import.meta.glob("./views/shop/*.vue");

function createAdRoutes(platforms, prefix, components) {
  return platforms.flatMap(
    ({ prefix: platformPrefix, versions, componentMap }) =>
      versions.map((version) => {
        // 确定组件路径
        const componentName = componentMap[version] || version;
        const componentPath = `./views/${prefix}/${componentName}.vue`;

        return {
          path: `${platformPrefix}-${version}`, // 子路由路径
          name: `${prefix}-${platformPrefix}-${version}`,
          component: components[componentPath], // 使用 import.meta.glob 动态导入组件
        };
      })
  );
}

const downRoutes = createAdRoutes(platforms, "down", downComponents);
// const shopRoutes = createAdRoutes(platforms, "shop", shopComponents);

// console.log("Down Routes:", downRoutes);
// console.log("Shop Routes:", shopRoutes);

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // 入口页面
    {
      path: "/",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title: "『三国志:戦乱』公式サイト-好評配信中！",
        description:
          "『三国志:戦乱』は今事前登録受付中！予約で王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "三国志:戦乱,三国志戦乱,戦乱,事前登録,予約,限定特典,豪華賞品,PS5,iphone,switch,報酬3000万,最強同盟争奪戦,事前結成,連盟,同盟,損ゼロ,村,経営,攻略,SLG,RPG,ROK,スマホゲーム,戦略,戦法,戦術,謀略,知略,歴史シミュレーション,攻城,自由,リアル,無料ゲーム,リアルタイム,武将育成,赤壁,三国志,歴史小説,RTS,3D,カード,共闘,ギルド,ジョブ,ガチャ,特典,育成,戦力,逆襲,自動戦闘,仲間,職業,キャラ,武将,経営,ストラテジースマホゲーム,senran孫尚香,張遼,関羽,馬超,孫権,曹操,劉備,小喬,大喬,貂蝉,周瑜,文明と征服,Era of Conquest,シヴィライゼーション,万国覚醒,ROK,SOS,三国志真戦,三國志,KOEI,コーエー,コーエーテクモ,こーえー,しんせん,せんりゃく,真戦,さんごくし,shinsen,sangokushi,三國,三国,三国志,三國志,真戦,光栄,三國志8,三國志覇道,三国覇王戦記,率土之滨,覇王の業,波乱の三国志クラッシュ・オブ・クラン,クラッシュ・オブ・キングス,Crusader Kings 3 ,エンパイア: トータル ウォー,AFK Arena,Lords Mobile,ラストウォー",
      },
    },
    {
      path: "/m",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title: "『三国志:戦乱』公式サイト-好評配信中！",
        description:
          "『三国志:戦乱』は今好評配信中！ダウンロードで王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "三国志:戦乱,三国志戦乱,戦乱,事前登録,予約,限定特典,豪華賞品,PS5,iphone,switch,報酬3000万,最強同盟争奪戦,事前結成,連盟,同盟,損ゼロ,村,経営,攻略,SLG,RPG,ROK,スマホゲーム,戦略,戦法,戦術,謀略,知略,歴史シミュレーション,攻城,自由,リアル,無料ゲーム,リアルタイム,武将育成,赤壁,三国志,歴史小説,RTS,3D,カード,共闘,ギルド,ジョブ,ガチャ,特典,育成,戦力,逆襲,自動戦闘,仲間,職業,キャラ,武将,経営,ストラテジースマホゲーム,senran孫尚香,張遼,関羽,馬超,孫権,曹操,劉備,小喬,大喬,貂蝉,周瑜,文明と征服,Era of Conquest,シヴィライゼーション,万国覚醒,ROK,SOS,三国志真戦,三國志,KOEI,コーエー,コーエーテクモ,こーえー,しんせん,せんりゃく,真戦,さんごくし,shinsen,sangokushi,三國,三国,三国志,三國志,真戦,光栄,三國志8,三國志覇道,三国覇王戦記,率土之滨,覇王の業,波乱の三国志クラッシュ・オブ・クラン,クラッシュ・オブ・キングス,Crusader Kings 3 ,エンパイア: トータル ウォー,AFK Arena,Lords Mobile,ラストウォー",
      },
    },

    {
      path: "/pre",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title: "『三国志:戦乱』事前登録受付中！",
        description:
          "『三国志:戦乱』は今事前登録受付中！予約で王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "三国志:戦乱,三国志戦乱,戦乱,事前登録,予約,限定特典,豪華賞品,PS5,iphone,switch,報酬3000万,最強同盟争奪戦,事前結成,連盟,同盟,損ゼロ,村,経営,攻略,SLG,RPG,ROK,スマホゲーム,戦略,戦法,戦術,謀略,知略,歴史シミュレーション,攻城,自由,リアル,無料ゲーム,リアルタイム,武将育成,赤壁,三国志,歴史小説,RTS,3D,カード,共闘,ギルド,ジョブ,ガチャ,特典,育成,戦力,逆襲,自動戦闘,仲間,職業,キャラ,武将,経営,ストラテジースマホゲーム,senran孫尚香,張遼,関羽,馬超,孫権,曹操,劉備,小喬,大喬,貂蝉,周瑜,文明と征服,Era of Conquest,シヴィライゼーション,万国覚醒,ROK,SOS,三国志真戦,三國志,KOEI,コーエー,コーエーテクモ,こーえー,しんせん,せんりゃく,真戦,さんごくし,shinsen,sangokushi,三國,三国,三国志,三國志,真戦,光栄,三國志8,三國志覇道,三国覇王戦記,率土之滨,覇王の業,波乱の三国志クラッシュ・オブ・クラン,クラッシュ・オブ・キングス,Crusader Kings 3 ,エンパイア: トータル ウォー,AFK Arena,Lords Mobile,ラストウォー",
      },
    },
    {
      path: "/pre/m",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title: "『三国志:戦乱』事前登録受付中！",
        description:
          "『三国志:戦乱』は今事前登録受付中！予約で王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "三国志:戦乱,三国志戦乱,戦乱,事前登録,予約,限定特典,豪華賞品,PS5,iphone,switch,報酬3000万,最強同盟争奪戦,事前結成,連盟,同盟,損ゼロ,村,経営,攻略,SLG,RPG,ROK,スマホゲーム,戦略,戦法,戦術,謀略,知略,歴史シミュレーション,攻城,自由,リアル,無料ゲーム,リアルタイム,武将育成,赤壁,三国志,歴史小説,RTS,3D,カード,共闘,ギルド,ジョブ,ガチャ,特典,育成,戦力,逆襲,自動戦闘,仲間,職業,キャラ,武将,経営,ストラテジースマホゲーム,senran孫尚香,張遼,関羽,馬超,孫権,曹操,劉備,小喬,大喬,貂蝉,周瑜,文明と征服,Era of Conquest,シヴィライゼーション,万国覚醒,ROK,SOS,三国志真戦,三國志,KOEI,コーエー,コーエーテクモ,こーえー,しんせん,せんりゃく,真戦,さんごくし,shinsen,sangokushi,三國,三国,三国志,三國志,真戦,光栄,三國志8,三國志覇道,三国覇王戦記,率土之滨,覇王の業,波乱の三国志クラッシュ・オブ・クラン,クラッシュ・オブ・キングス,Crusader Kings 3 ,エンパイア: トータル ウォー,AFK Arena,Lords Mobile,ラストウォー",
      },
    },
    // 广告投放营销预约页FB-X渠道
    {
      path: "/pre/FB",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "『三国志:戦乱』事前登録受付中！",
        description:
          "『三国志:戦乱』は今事前登録受付中！予約で王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "三国志:戦乱,三国志戦乱,戦乱,事前登録,予約,限定特典,豪華賞品,PS5,iphone,switch,報酬3000万,最強同盟争奪戦,事前結成,連盟,同盟,損ゼロ,村,経営,攻略,SLG,RPG,ROK,スマホゲーム,戦略,戦法,戦術,謀略,知略,歴史シミュレーション,攻城,自由,リアル,無料ゲーム,リアルタイム,武将育成,赤壁,三国志,歴史小説,RTS,3D,カード,共闘,ギルド,ジョブ,ガチャ,特典,育成,戦力,逆襲,自動戦闘,仲間,職業,キャラ,武将,経営,ストラテジースマホゲーム,senran孫尚香,張遼,関羽,馬超,孫権,曹操,劉備,小喬,大喬,貂蝉,周瑜,文明と征服,Era of Conquest,シヴィライゼーション,万国覚醒,ROK,SOS,三国志真戦,三國志,KOEI,コーエー,コーエーテクモ,こーえー,しんせん,せんりゃく,真戦,さんごくし,shinsen,sangokushi,三國,三国,三国志,三國志,真戦,光栄,三國志8,三國志覇道,三国覇王戦記,率土之滨,覇王の業,波乱の三国志クラッシュ・オブ・クラン,クラッシュ・オブ・キングス,Crusader Kings 3 ,エンパイア: トータル ウォー,AFK Arena,Lords Mobile,ラストウォー",
      },
    },
    {
      path: "/pre/FB/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "『三国志:戦乱』事前登録受付中！",
        description:
          "『三国志:戦乱』は今事前登録受付中！予約で王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "三国志:戦乱,三国志戦乱,戦乱,事前登録,予約,限定特典,豪華賞品,PS5,iphone,switch,報酬3000万,最強同盟争奪戦,事前結成,連盟,同盟,損ゼロ,村,経営,攻略,SLG,RPG,ROK,スマホゲーム,戦略,戦法,戦術,謀略,知略,歴史シミュレーション,攻城,自由,リアル,無料ゲーム,リアルタイム,武将育成,赤壁,三国志,歴史小説,RTS,3D,カード,共闘,ギルド,ジョブ,ガチャ,特典,育成,戦力,逆襲,自動戦闘,仲間,職業,キャラ,武将,経営,ストラテジースマホゲーム,senran孫尚香,張遼,関羽,馬超,孫権,曹操,劉備,小喬,大喬,貂蝉,周瑜,文明と征服,Era of Conquest,シヴィライゼーション,万国覚醒,ROK,SOS,三国志真戦,三國志,KOEI,コーエー,コーエーテクモ,こーえー,しんせん,せんりゃく,真戦,さんごくし,shinsen,sangokushi,三國,三国,三国志,三國志,真戦,光栄,三國志8,三國志覇道,三国覇王戦記,率土之滨,覇王の業,波乱の三国志クラッシュ・オブ・クラン,クラッシュ・オブ・キングス,Crusader Kings 3 ,エンパイア: トータル ウォー,AFK Arena,Lords Mobile,ラストウォー",
      },
    },
    // 广告投放营销预约页GG-Y渠道
    {
      path: "/pre/GG",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "『三国志:戦乱』事前登録受付中！",
        description:
          "『三国志:戦乱』は今事前登録受付中！予約で王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "三国志:戦乱,三国志戦乱,戦乱,事前登録,予約,限定特典,豪華賞品,PS5,iphone,switch,報酬3000万,最強同盟争奪戦,事前結成,連盟,同盟,損ゼロ,村,経営,攻略,SLG,RPG,ROK,スマホゲーム,戦略,戦法,戦術,謀略,知略,歴史シミュレーション,攻城,自由,リアル,無料ゲーム,リアルタイム,武将育成,赤壁,三国志,歴史小説,RTS,3D,カード,共闘,ギルド,ジョブ,ガチャ,特典,育成,戦力,逆襲,自動戦闘,仲間,職業,キャラ,武将,経営,ストラテジースマホゲーム,senran孫尚香,張遼,関羽,馬超,孫権,曹操,劉備,小喬,大喬,貂蝉,周瑜,文明と征服,Era of Conquest,シヴィライゼーション,万国覚醒,ROK,SOS,三国志真戦,三國志,KOEI,コーエー,コーエーテクモ,こーえー,しんせん,せんりゃく,真戦,さんごくし,shinsen,sangokushi,三國,三国,三国志,三國志,真戦,光栄,三國志8,三國志覇道,三国覇王戦記,率土之滨,覇王の業,波乱の三国志クラッシュ・オブ・クラン,クラッシュ・オブ・キングス,Crusader Kings 3 ,エンパイア: トータル ウォー,AFK Arena,Lords Mobile,ラストウォー",
      },
    },
    {
      path: "/pre/GG/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "『三国志:戦乱』事前登録受付中！",
        description:
          "『三国志:戦乱』は今事前登録受付中！予約で王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "三国志:戦乱,三国志戦乱,戦乱,事前登録,予約,限定特典,豪華賞品,PS5,iphone,switch,報酬3000万,最強同盟争奪戦,事前結成,連盟,同盟,損ゼロ,村,経営,攻略,SLG,RPG,ROK,スマホゲーム,戦略,戦法,戦術,謀略,知略,歴史シミュレーション,攻城,自由,リアル,無料ゲーム,リアルタイム,武将育成,赤壁,三国志,歴史小説,RTS,3D,カード,共闘,ギルド,ジョブ,ガチャ,特典,育成,戦力,逆襲,自動戦闘,仲間,職業,キャラ,武将,経営,ストラテジースマホゲーム,senran孫尚香,張遼,関羽,馬超,孫権,曹操,劉備,小喬,大喬,貂蝉,周瑜,文明と征服,Era of Conquest,シヴィライゼーション,万国覚醒,ROK,SOS,三国志真戦,三國志,KOEI,コーエー,コーエーテクモ,こーえー,しんせん,せんりゃく,真戦,さんごくし,shinsen,sangokushi,三國,三国,三国志,三國志,真戦,光栄,三國志8,三國志覇道,三国覇王戦記,率土之滨,覇王の業,波乱の三国志クラッシュ・オブ・クラン,クラッシュ・オブ・キングス,Crusader Kings 3 ,エンパイア: トータル ウォー,AFK Arena,Lords Mobile,ラストウォー",
      },
    },
    // 广告投放营销预约页GG1渠道
    {
      path: "/pre/GG1",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "『三国志:戦乱』事前登録受付中！",
        description:
          "『三国志:戦乱』は今事前登録受付中！予約で王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "三国志:戦乱,三国志戦乱,戦乱,事前登録,予約,限定特典,豪華賞品,PS5,iphone,switch,報酬3000万,最強同盟争奪戦,事前結成,連盟,同盟,損ゼロ,村,経営,攻略,SLG,RPG,ROK,スマホゲーム,戦略,戦法,戦術,謀略,知略,歴史シミュレーション,攻城,自由,リアル,無料ゲーム,リアルタイム,武将育成,赤壁,三国志,歴史小説,RTS,3D,カード,共闘,ギルド,ジョブ,ガチャ,特典,育成,戦力,逆襲,自動戦闘,仲間,職業,キャラ,武将,経営,ストラテジースマホゲーム,senran孫尚香,張遼,関羽,馬超,孫権,曹操,劉備,小喬,大喬,貂蝉,周瑜,文明と征服,Era of Conquest,シヴィライゼーション,万国覚醒,ROK,SOS,三国志真戦,三國志,KOEI,コーエー,コーエーテクモ,こーえー,しんせん,せんりゃく,真戦,さんごくし,shinsen,sangokushi,三國,三国,三国志,三國志,真戦,光栄,三國志8,三國志覇道,三国覇王戦記,率土之滨,覇王の業,波乱の三国志クラッシュ・オブ・クラン,クラッシュ・オブ・キングス,Crusader Kings 3 ,エンパイア: トータル ウォー,AFK Arena,Lords Mobile,ラストウォー",
      },
    },
    {
      path: "/pre/GG1/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "『三国志:戦乱』事前登録受付中！",
        description:
          "『三国志:戦乱』は今事前登録受付中！予約で王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "三国志:戦乱,三国志戦乱,戦乱,事前登録,予約,限定特典,豪華賞品,PS5,iphone,switch,報酬3000万,最強同盟争奪戦,事前結成,連盟,同盟,損ゼロ,村,経営,攻略,SLG,RPG,ROK,スマホゲーム,戦略,戦法,戦術,謀略,知略,歴史シミュレーション,攻城,自由,リアル,無料ゲーム,リアルタイム,武将育成,赤壁,三国志,歴史小説,RTS,3D,カード,共闘,ギルド,ジョブ,ガチャ,特典,育成,戦力,逆襲,自動戦闘,仲間,職業,キャラ,武将,経営,ストラテジースマホゲーム,senran孫尚香,張遼,関羽,馬超,孫権,曹操,劉備,小喬,大喬,貂蝉,周瑜,文明と征服,Era of Conquest,シヴィライゼーション,万国覚醒,ROK,SOS,三国志真戦,三國志,KOEI,コーエー,コーエーテクモ,こーえー,しんせん,せんりゃく,真戦,さんごくし,shinsen,sangokushi,三國,三国,三国志,三國志,真戦,光栄,三國志8,三國志覇道,三国覇王戦記,率土之滨,覇王の業,波乱の三国志クラッシュ・オブ・クラン,クラッシュ・オブ・キングス,Crusader Kings 3 ,エンパイア: トータル ウォー,AFK Arena,Lords Mobile,ラストウォー",
      },
    },
    // 广告投放营销预约页GG2渠道
    {
      path: "/pre/GG2",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "『三国志:戦乱』事前登録受付中！",
        description:
          "『三国志:戦乱』は今事前登録受付中！予約で王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "三国志:戦乱,三国志戦乱,戦乱,事前登録,予約,限定特典,豪華賞品,PS5,iphone,switch,報酬3000万,最強同盟争奪戦,事前結成,連盟,同盟,損ゼロ,村,経営,攻略,SLG,RPG,ROK,スマホゲーム,戦略,戦法,戦術,謀略,知略,歴史シミュレーション,攻城,自由,リアル,無料ゲーム,リアルタイム,武将育成,赤壁,三国志,歴史小説,RTS,3D,カード,共闘,ギルド,ジョブ,ガチャ,特典,育成,戦力,逆襲,自動戦闘,仲間,職業,キャラ,武将,経営,ストラテジースマホゲーム,senran孫尚香,張遼,関羽,馬超,孫権,曹操,劉備,小喬,大喬,貂蝉,周瑜,文明と征服,Era of Conquest,シヴィライゼーション,万国覚醒,ROK,SOS,三国志真戦,三國志,KOEI,コーエー,コーエーテクモ,こーえー,しんせん,せんりゃく,真戦,さんごくし,shinsen,sangokushi,三國,三国,三国志,三國志,真戦,光栄,三國志8,三國志覇道,三国覇王戦記,率土之滨,覇王の業,波乱の三国志クラッシュ・オブ・クラン,クラッシュ・オブ・キングス,Crusader Kings 3 ,エンパイア: トータル ウォー,AFK Arena,Lords Mobile,ラストウォー",
      },
    },
    {
      path: "/pre/GG2/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "『三国志:戦乱』事前登録受付中！",
        description:
          "『三国志:戦乱』は今事前登録受付中！予約で王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "三国志:戦乱,三国志戦乱,戦乱,事前登録,予約,限定特典,豪華賞品,PS5,iphone,switch,報酬3000万,最強同盟争奪戦,事前結成,連盟,同盟,損ゼロ,村,経営,攻略,SLG,RPG,ROK,スマホゲーム,戦略,戦法,戦術,謀略,知略,歴史シミュレーション,攻城,自由,リアル,無料ゲーム,リアルタイム,武将育成,赤壁,三国志,歴史小説,RTS,3D,カード,共闘,ギルド,ジョブ,ガチャ,特典,育成,戦力,逆襲,自動戦闘,仲間,職業,キャラ,武将,経営,ストラテジースマホゲーム,senran孫尚香,張遼,関羽,馬超,孫権,曹操,劉備,小喬,大喬,貂蝉,周瑜,文明と征服,Era of Conquest,シヴィライゼーション,万国覚醒,ROK,SOS,三国志真戦,三國志,KOEI,コーエー,コーエーテクモ,こーえー,しんせん,せんりゃく,真戦,さんごくし,shinsen,sangokushi,三國,三国,三国志,三國志,真戦,光栄,三國志8,三國志覇道,三国覇王戦記,率土之滨,覇王の業,波乱の三国志クラッシュ・オブ・クラン,クラッシュ・オブ・キングス,Crusader Kings 3 ,エンパイア: トータル ウォー,AFK Arena,Lords Mobile,ラストウォー",
      },
    },
    // 广告投放营销预约页TT-Z渠道
    {
      path: "/pre/TT",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "『三国志:戦乱』事前登録受付中！",
        description:
          "『三国志:戦乱』は今事前登録受付中！予約で王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "三国志:戦乱,三国志戦乱,戦乱,事前登録,予約,限定特典,豪華賞品,PS5,iphone,switch,報酬3000万,最強同盟争奪戦,事前結成,連盟,同盟,損ゼロ,村,経営,攻略,SLG,RPG,ROK,スマホゲーム,戦略,戦法,戦術,謀略,知略,歴史シミュレーション,攻城,自由,リアル,無料ゲーム,リアルタイム,武将育成,赤壁,三国志,歴史小説,RTS,3D,カード,共闘,ギルド,ジョブ,ガチャ,特典,育成,戦力,逆襲,自動戦闘,仲間,職業,キャラ,武将,経営,ストラテジースマホゲーム,senran孫尚香,張遼,関羽,馬超,孫権,曹操,劉備,小喬,大喬,貂蝉,周瑜,文明と征服,Era of Conquest,シヴィライゼーション,万国覚醒,ROK,SOS,三国志真戦,三國志,KOEI,コーエー,コーエーテクモ,こーえー,しんせん,せんりゃく,真戦,さんごくし,shinsen,sangokushi,三國,三国,三国志,三國志,真戦,光栄,三國志8,三國志覇道,三国覇王戦記,率土之滨,覇王の業,波乱の三国志クラッシュ・オブ・クラン,クラッシュ・オブ・キングス,Crusader Kings 3 ,エンパイア: トータル ウォー,AFK Arena,Lords Mobile,ラストウォー",
      },
    },
    {
      path: "/pre/TT/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "『三国志:戦乱』事前登録受付中！",
        description:
          "『三国志:戦乱』は今事前登録受付中！予約で王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "三国志:戦乱,三国志戦乱,戦乱,事前登録,予約,限定特典,豪華賞品,PS5,iphone,switch,報酬3000万,最強同盟争奪戦,事前結成,連盟,同盟,損ゼロ,村,経営,攻略,SLG,RPG,ROK,スマホゲーム,戦略,戦法,戦術,謀略,知略,歴史シミュレーション,攻城,自由,リアル,無料ゲーム,リアルタイム,武将育成,赤壁,三国志,歴史小説,RTS,3D,カード,共闘,ギルド,ジョブ,ガチャ,特典,育成,戦力,逆襲,自動戦闘,仲間,職業,キャラ,武将,経営,ストラテジースマホゲーム,senran孫尚香,張遼,関羽,馬超,孫権,曹操,劉備,小喬,大喬,貂蝉,周瑜,文明と征服,Era of Conquest,シヴィライゼーション,万国覚醒,ROK,SOS,三国志真戦,三國志,KOEI,コーエー,コーエーテクモ,こーえー,しんせん,せんりゃく,真戦,さんごくし,shinsen,sangokushi,三國,三国,三国志,三國志,真戦,光栄,三國志8,三國志覇道,三国覇王戦記,率土之滨,覇王の業,波乱の三国志クラッシュ・オブ・クラン,クラッシュ・オブ・キングス,Crusader Kings 3 ,エンパイア: トータル ウォー,AFK Arena,Lords Mobile,ラストウォー",
      },
    },
    {
      path: "/challenge",
      component: () => import("./views/challenge/index.vue"),
      meta: {
        title: "『三国志:戦乱』連盟事前結成特設サイト",
        description:
          "『三国志:戦乱』は今事前登録受付中！予約で王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "三国志:戦乱,三国志戦乱,戦乱,事前登録,予約,限定特典,豪華賞品,PS5,iphone,switch,報酬3000万,最強同盟争奪戦,事前結成,連盟,同盟,損ゼロ,村,経営,攻略,SLG,RPG,ROK,スマホゲーム,戦略,戦法,戦術,謀略,知略,歴史シミュレーション,攻城,自由,リアル,無料ゲーム,リアルタイム,武将育成,赤壁,三国志,歴史小説,RTS,3D,カード,共闘,ギルド,ジョブ,ガチャ,特典,育成,戦力,逆襲,自動戦闘,仲間,職業,キャラ,武将,経営,ストラテジースマホゲーム,senran孫尚香,張遼,関羽,馬超,孫権,曹操,劉備,小喬,大喬,貂蝉,周瑜,文明と征服,Era of Conquest,シヴィライゼーション,万国覚醒,ROK,SOS,三国志真戦,三國志,KOEI,コーエー,コーエーテクモ,こーえー,しんせん,せんりゃく,真戦,さんごくし,shinsen,sangokushi,三國,三国,三国志,三國志,真戦,光栄,三國志8,三國志覇道,三国覇王戦記,率土之滨,覇王の業,波乱の三国志クラッシュ・オブ・クラン,クラッシュ・オブ・キングス,Crusader Kings 3 ,エンパイア: トータル ウォー,AFK Arena,Lords Mobile,ラストウォー",
      },
    },
    {
      path: "/challenge/m",
      component: () => import("./views/challenge/index.vue"),
      meta: {
        title: "『三国志:戦乱』連盟事前結成特設サイト",
        description:
          "『三国志:戦乱』は今事前登録受付中！予約で王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "三国志:戦乱,三国志戦乱,戦乱,事前登録,予約,限定特典,豪華賞品,PS5,iphone,switch,報酬3000万,最強同盟争奪戦,事前結成,連盟,同盟,損ゼロ,村,経営,攻略,SLG,RPG,ROK,スマホゲーム,戦略,戦法,戦術,謀略,知略,歴史シミュレーション,攻城,自由,リアル,無料ゲーム,リアルタイム,武将育成,赤壁,三国志,歴史小説,RTS,3D,カード,共闘,ギルド,ジョブ,ガチャ,特典,育成,戦力,逆襲,自動戦闘,仲間,職業,キャラ,武将,経営,ストラテジースマホゲーム,senran孫尚香,張遼,関羽,馬超,孫権,曹操,劉備,小喬,大喬,貂蝉,周瑜,文明と征服,Era of Conquest,シヴィライゼーション,万国覚醒,ROK,SOS,三国志真戦,三國志,KOEI,コーエー,コーエーテクモ,こーえー,しんせん,せんりゃく,真戦,さんごくし,shinsen,sangokushi,三國,三国,三国志,三國志,真戦,光栄,三國志8,三國志覇道,三国覇王戦記,率土之滨,覇王の業,波乱の三国志クラッシュ・オブ・クラン,クラッシュ・オブ・キングス,Crusader Kings 3 ,エンパイア: トータル ウォー,AFK Arena,Lords Mobile,ラストウォー",
      },
    },
    // 官网首页
    {
      path: "/home",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title: "『三国志:戦乱』公式サイト-好評配信中！",
        description:
          "『三国志:戦乱』は今事前登録受付中！予約で王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "三国志:戦乱,三国志戦乱,戦乱,事前登録,予約,限定特典,豪華賞品,PS5,iphone,switch,報酬3000万,最強同盟争奪戦,事前結成,連盟,同盟,損ゼロ,村,経営,攻略,SLG,RPG,ROK,スマホゲーム,戦略,戦法,戦術,謀略,知略,歴史シミュレーション,攻城,自由,リアル,無料ゲーム,リアルタイム,武将育成,赤壁,三国志,歴史小説,RTS,3D,カード,共闘,ギルド,ジョブ,ガチャ,特典,育成,戦力,逆襲,自動戦闘,仲間,職業,キャラ,武将,経営,ストラテジースマホゲーム,senran孫尚香,張遼,関羽,馬超,孫権,曹操,劉備,小喬,大喬,貂蝉,周瑜,文明と征服,Era of Conquest,シヴィライゼーション,万国覚醒,ROK,SOS,三国志真戦,三國志,KOEI,コーエー,コーエーテクモ,こーえー,しんせん,せんりゃく,真戦,さんごくし,shinsen,sangokushi,三國,三国,三国志,三國志,真戦,光栄,三國志8,三國志覇道,三国覇王戦記,率土之滨,覇王の業,波乱の三国志クラッシュ・オブ・クラン,クラッシュ・オブ・キングス,Crusader Kings 3 ,エンパイア: トータル ウォー,AFK Arena,Lords Mobile,ラストウォー",
      },
    },
    {
      path: "/home/m",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title: "『三国志:戦乱』公式サイト-好評配信中！",
        description:
          "『三国志:戦乱』は今好評配信中！ダウンロードで王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "三国志:戦乱,三国志戦乱,戦乱,事前登録,予約,限定特典,豪華賞品,PS5,iphone,switch,報酬3000万,最強同盟争奪戦,事前結成,連盟,同盟,損ゼロ,村,経営,攻略,SLG,RPG,ROK,スマホゲーム,戦略,戦法,戦術,謀略,知略,歴史シミュレーション,攻城,自由,リアル,無料ゲーム,リアルタイム,武将育成,赤壁,三国志,歴史小説,RTS,3D,カード,共闘,ギルド,ジョブ,ガチャ,特典,育成,戦力,逆襲,自動戦闘,仲間,職業,キャラ,武将,経営,ストラテジースマホゲーム,senran孫尚香,張遼,関羽,馬超,孫権,曹操,劉備,小喬,大喬,貂蝉,周瑜,文明と征服,Era of Conquest,シヴィライゼーション,万国覚醒,ROK,SOS,三国志真戦,三國志,KOEI,コーエー,コーエーテクモ,こーえー,しんせん,せんりゃく,真戦,さんごくし,shinsen,sangokushi,三國,三国,三国志,三國志,真戦,光栄,三國志8,三國志覇道,三国覇王戦記,率土之滨,覇王の業,波乱の三国志クラッシュ・オブ・クラン,クラッシュ・オブ・キングス,Crusader Kings 3 ,エンパイア: トータル ウォー,AFK Arena,Lords Mobile,ラストウォー",
      },
    },
    // 官网新闻
    {
      path: "/news",
      component: () => import("./views/yygw/news.vue"),
      meta: {
        title: "삼국지:전란-부담 제로, 전략으로 승부하라!",
        keywords:
          "삼국지:전란,삼국지,전란,ㅅㄱㅈ,삼국,samguk, samgukji, 쿠카,Qookka,SLG,삼전,삼국지 전략판,인피니트 보더스,삼국지워,킹스 엠파이어,진 · 삼국무쌍 M,삼국지: 패도,삼국지 오리진2: 적벽대전,신삼국:명장,라이즈 오브 킹덤즈, 삼국지M,삼국블레이드,MMO,RTS,예약,예약 페이지,국가전,한국,무료,직업,리얼한 삼국,자유,시뮬레이션,경영,화공,전략, 전쟁,전략형,모바일 게임, iOS, App,Android, guide,3D,1억,1억 상금,관도대전,군웅할거,도원결의,촉,위,오,제갈량,유비,조조,손권,부담 제로, 전략으로 승부하라,공식라운지,역사 소설,삼국지8 REMAKE,삼국지14,삼국지 13,삼국지14 with 파워업키트,엠파이어: War for Dominion,WOS: 화이트아웃 서바이벌,라스트 워: 서바이벌,삼국 올스타,랑그릿사,리니지2 레볼루션,전란: 천하쟁패,에이지 오브 엠파이어 모바일,EOC: 제국정복",
        description:
          "《삼국지:전란》은 다양한 직업, 리얼한 삼국 SLG 혁신 대작으로, 전략을 짜고 삼국을 제패하는 짜릿함을 즐길 수 있는 게임입니다. 지금 사전 예약하면 희귀 무장 2명과 최대 1190회 무료 모집 기획을 바로 획득 가능합니다! 게임에서는 처음으로 마을 경영 콘텐츠과 다양한 직업 시스템을 도입하였고 번거로움 없이 자원을 자급자족하며 쉽게 성장할 수 있습니다. 또한 청낭, 협객, 농부 세 가지 특색 직업을 선택하여 다양한 직업 스킬로 전장을 지배할 수 있습니다",
      },
    },
    {
      path: "/news/m",
      component: () => import("./views/yygw/news.vue"),
      meta: {
        title: "삼국지:전란-부담 제로, 전략으로 승부하라!",
        keywords:
          "삼국지:전란,삼국지,전란,ㅅㄱㅈ,삼국,samguk, samgukji, 쿠카,Qookka,SLG,삼전,삼국지 전략판,인피니트 보더스,삼국지워,킹스 엠파이어,진 · 삼국무쌍 M,삼국지: 패도,삼국지 오리진2: 적벽대전,신삼국:명장,라이즈 오브 킹덤즈, 삼국지M,삼국블레이드,MMO,RTS,예약,예약 페이지,국가전,한국,무료,직업,리얼한 삼국,자유,시뮬레이션,경영,화공,전략, 전쟁,전략형,모바일 게임, iOS, App,Android, guide,3D,1억,1억 상금,관도대전,군웅할거,도원결의,촉,위,오,제갈량,유비,조조,손권,부담 제로, 전략으로 승부하라,공식라운지,역사 소설,삼국지8 REMAKE,삼국지14,삼국지 13,삼국지14 with 파워업키트,엠파이어: War for Dominion,WOS: 화이트아웃 서바이벌,라스트 워: 서바이벌,삼국 올스타,랑그릿사,리니지2 레볼루션,전란: 천하쟁패,에이지 오브 엠파이어 모바일,EOC: 제국정복",
        description:
          "《삼국지:전란》은 다양한 직업, 리얼한 삼국 SLG 혁신 대작으로, 전략을 짜고 삼국을 제패하는 짜릿함을 즐길 수 있는 게임입니다. 지금 사전 예약하면 희귀 무장 2명과 최대 1190회 무료 모집 기획을 바로 획득 가능합니다! 게임에서는 처음으로 마을 경영 콘텐츠과 다양한 직업 시스템을 도입하였고 번거로움 없이 자원을 자급자족하며 쉽게 성장할 수 있습니다. 또한 청낭, 협객, 농부 세 가지 특색 직업을 선택하여 다양한 직업 스킬로 전장을 지배할 수 있습니다",
      },
    },
    // 官网内容
    {
      path: "/content",
      component: () => import("./views/yygw/content.vue"),
      meta: {
        title: "삼국지:전란-부담 제로, 전략으로 승부하라!",
        keywords:
          "삼국지:전란,삼국지,전란,ㅅㄱㅈ,삼국,samguk, samgukji, 쿠카,Qookka,SLG,삼전,삼국지 전략판,인피니트 보더스,삼국지워,킹스 엠파이어,진 · 삼국무쌍 M,삼국지: 패도,삼국지 오리진2: 적벽대전,신삼국:명장,라이즈 오브 킹덤즈, 삼국지M,삼국블레이드,MMO,RTS,예약,예약 페이지,국가전,한국,무료,직업,리얼한 삼국,자유,시뮬레이션,경영,화공,전략, 전쟁,전략형,모바일 게임, iOS, App,Android, guide,3D,1억,1억 상금,관도대전,군웅할거,도원결의,촉,위,오,제갈량,유비,조조,손권,부담 제로, 전략으로 승부하라,공식라운지,역사 소설,삼국지8 REMAKE,삼국지14,삼국지 13,삼국지14 with 파워업키트,엠파이어: War for Dominion,WOS: 화이트아웃 서바이벌,라스트 워: 서바이벌,삼국 올스타,랑그릿사,리니지2 레볼루션,전란: 천하쟁패,에이지 오브 엠파이어 모바일,EOC: 제국정복",
        description:
          "《삼국지:전란》은 다양한 직업, 리얼한 삼국 SLG 혁신 대작으로, 전략을 짜고 삼국을 제패하는 짜릿함을 즐길 수 있는 게임입니다. 지금 사전 예약하면 희귀 무장 2명과 최대 1190회 무료 모집 기획을 바로 획득 가능합니다! 게임에서는 처음으로 마을 경영 콘텐츠과 다양한 직업 시스템을 도입하였고 번거로움 없이 자원을 자급자족하며 쉽게 성장할 수 있습니다. 또한 청낭, 협객, 농부 세 가지 특색 직업을 선택하여 다양한 직업 스킬로 전장을 지배할 수 있습니다",
      },
    },
    {
      path: "/content/m",
      component: () => import("./views/yygw/content.vue"),
      meta: {
        title: "삼국지:전란-부담 제로, 전략으로 승부하라!",
        keywords:
          "삼국지:전란,삼국지,전란,ㅅㄱㅈ,삼국,samguk, samgukji, 쿠카,Qookka,SLG,삼전,삼국지 전략판,인피니트 보더스,삼국지워,킹스 엠파이어,진 · 삼국무쌍 M,삼국지: 패도,삼국지 오리진2: 적벽대전,신삼국:명장,라이즈 오브 킹덤즈, 삼국지M,삼국블레이드,MMO,RTS,예약,예약 페이지,국가전,한국,무료,직업,리얼한 삼국,자유,시뮬레이션,경영,화공,전략, 전쟁,전략형,모바일 게임, iOS, App,Android, guide,3D,1억,1억 상금,관도대전,군웅할거,도원결의,촉,위,오,제갈량,유비,조조,손권,부담 제로, 전략으로 승부하라,공식라운지,역사 소설,삼국지8 REMAKE,삼국지14,삼국지 13,삼국지14 with 파워업키트,엠파이어: War for Dominion,WOS: 화이트아웃 서바이벌,라스트 워: 서바이벌,삼국 올스타,랑그릿사,리니지2 레볼루션,전란: 천하쟁패,에이지 오브 엠파이어 모바일,EOC: 제국정복",
        description:
          "《삼국지:전란》은 다양한 직업, 리얼한 삼국 SLG 혁신 대작으로, 전략을 짜고 삼국을 제패하는 짜릿함을 즐길 수 있는 게임입니다. 지금 사전 예약하면 희귀 무장 2명과 최대 1190회 무료 모집 기획을 바로 획득 가능합니다! 게임에서는 처음으로 마을 경영 콘텐츠과 다양한 직업 시스템을 도입하였고 번거로움 없이 자원을 자급자족하며 쉽게 성장할 수 있습니다. 또한 청낭, 협객, 농부 세 가지 특색 직업을 선택하여 다양한 직업 스킬로 전장을 지배할 수 있습니다",
      },
    },
    // 下载
    {
      path: "/down",
      meta: {
        title: "『三国志:戦乱』事前登録受付中！",
        description:
          "『三国志:戦乱』は今事前登録受付中！予約で王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "スマホゲーム、三國志、三国志、策略、謀略、SLG、ストラテジー、KOEI、コーエー、コーエーテクモ、こーえー、しんせん、せんりゃく、真戦、さんごくし、shinsen、sangokushi三國、三国、三国志、三國志、真戦、コーエー、光栄、最強同盟争覇戦",
      },
      children: downRoutes,
    },
    // 攻略站
    {
      path: "/station/",
      component: () => import("./views/station/index.vue"),
      meta: {
        title: "『三国志:戦乱』事前登録受付中！",
        keepAlive: true,
        description:
          "『三国志:戦乱』は今事前登録受付中！予約で王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "三国志:戦乱,三国志戦乱,戦乱,事前登録,予約,限定特典,豪華賞品,PS5,iphone,switch,報酬3000万,最強同盟争奪戦,事前結成,連盟,同盟,損ゼロ,村,経営,攻略,SLG,RPG,ROK,スマホゲーム,戦略,戦法,戦術,謀略,知略,歴史シミュレーション,攻城,自由,リアル,無料ゲーム,リアルタイム,武将育成,赤壁,三国志,歴史小説,RTS,3D,カード,共闘,ギルド,ジョブ,ガチャ,特典,育成,戦力,逆襲,自動戦闘,仲間,職業,キャラ,武将,経営,ストラテジースマホゲーム,senran孫尚香,張遼,関羽,馬超,孫権,曹操,劉備,小喬,大喬,貂蝉,周瑜,文明と征服,Era of Conquest,シヴィライゼーション,万国覚醒,ROK,SOS,三国志真戦,三國志,KOEI,コーエー,コーエーテクモ,こーえー,しんせん,せんりゃく,真戦,さんごくし,shinsen,sangokushi,三國,三国,三国志,三國志,真戦,光栄,三國志8,三國志覇道,三国覇王戦記,率土之滨,覇王の業,波乱の三国志クラッシュ・オブ・クラン,クラッシュ・オブ・キングス,Crusader Kings 3 ,エンパイア: トータル ウォー,AFK Arena,Lords Mobile,ラストウォー",
      },
    },
    {
      path: "/station/m",
      component: () => import("./views/station/index.vue"),
      meta: {
        title: "『三国志:戦乱』事前登録受付中！",
        keepAlive: true,
        description:
          "『三国志:戦乱』は今事前登録受付中！予約で王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "三国志:戦乱,三国志戦乱,戦乱,事前登録,予約,限定特典,豪華賞品,PS5,iphone,switch,報酬3000万,最強同盟争奪戦,事前結成,連盟,同盟,損ゼロ,村,経営,攻略,SLG,RPG,ROK,スマホゲーム,戦略,戦法,戦術,謀略,知略,歴史シミュレーション,攻城,自由,リアル,無料ゲーム,リアルタイム,武将育成,赤壁,三国志,歴史小説,RTS,3D,カード,共闘,ギルド,ジョブ,ガチャ,特典,育成,戦力,逆襲,自動戦闘,仲間,職業,キャラ,武将,経営,ストラテジースマホゲーム,senran孫尚香,張遼,関羽,馬超,孫権,曹操,劉備,小喬,大喬,貂蝉,周瑜,文明と征服,Era of Conquest,シヴィライゼーション,万国覚醒,ROK,SOS,三国志真戦,三國志,KOEI,コーエー,コーエーテクモ,こーえー,しんせん,せんりゃく,真戦,さんごくし,shinsen,sangokushi,三國,三国,三国志,三國志,真戦,光栄,三國志8,三國志覇道,三国覇王戦記,率土之滨,覇王の業,波乱の三国志クラッシュ・オブ・クラン,クラッシュ・オブ・キングス,Crusader Kings 3 ,エンパイア: トータル ウォー,AFK Arena,Lords Mobile,ラストウォー",
      },
    },
    // 文章详情
    {
      path: "/article/m",
      component: () => import("./views/station/com/Article.vue"),
      meta: {
        title: "『三国志:戦乱』事前登録受付中！",
        description:
          "『三国志:戦乱』は今事前登録受付中！予約で王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "三国志:戦乱,三国志戦乱,戦乱,事前登録,予約,限定特典,豪華賞品,PS5,iphone,switch,報酬3000万,最強同盟争奪戦,事前結成,連盟,同盟,損ゼロ,村,経営,攻略,SLG,RPG,ROK,スマホゲーム,戦略,戦法,戦術,謀略,知略,歴史シミュレーション,攻城,自由,リアル,無料ゲーム,リアルタイム,武将育成,赤壁,三国志,歴史小説,RTS,3D,カード,共闘,ギルド,ジョブ,ガチャ,特典,育成,戦力,逆襲,自動戦闘,仲間,職業,キャラ,武将,経営,ストラテジースマホゲーム,senran孫尚香,張遼,関羽,馬超,孫権,曹操,劉備,小喬,大喬,貂蝉,周瑜,文明と征服,Era of Conquest,シヴィライゼーション,万国覚醒,ROK,SOS,三国志真戦,三國志,KOEI,コーエー,コーエーテクモ,こーえー,しんせん,せんりゃく,真戦,さんごくし,shinsen,sangokushi,三國,三国,三国志,三國志,真戦,光栄,三國志8,三國志覇道,三国覇王戦記,率土之滨,覇王の業,波乱の三国志クラッシュ・オブ・クラン,クラッシュ・オブ・キングス,Crusader Kings 3 ,エンパイア: トータル ウォー,AFK Arena,Lords Mobile,ラストウォー",
      },
      props: (route) => ({
        id: route.query.id,
        columnsId: route.query.columnsId,
      }),
    },
    {
      path: "/article/",
      component: () => import("./views/station/com/Article.vue"),
      meta: {
        title: "『三国志:戦乱』事前登録受付中！",
        description:
          "『三国志:戦乱』は今事前登録受付中！予約で王佐武将、最大280連ガチャなどの豪華特典をゲット！",
        keywords:
          "三国志:戦乱,三国志戦乱,戦乱,事前登録,予約,限定特典,豪華賞品,PS5,iphone,switch,報酬3000万,最強同盟争奪戦,事前結成,連盟,同盟,損ゼロ,村,経営,攻略,SLG,RPG,ROK,スマホゲーム,戦略,戦法,戦術,謀略,知略,歴史シミュレーション,攻城,自由,リアル,無料ゲーム,リアルタイム,武将育成,赤壁,三国志,歴史小説,RTS,3D,カード,共闘,ギルド,ジョブ,ガチャ,特典,育成,戦力,逆襲,自動戦闘,仲間,職業,キャラ,武将,経営,ストラテジースマホゲーム,senran孫尚香,張遼,関羽,馬超,孫権,曹操,劉備,小喬,大喬,貂蝉,周瑜,文明と征服,Era of Conquest,シヴィライゼーション,万国覚醒,ROK,SOS,三国志真戦,三國志,KOEI,コーエー,コーエーテクモ,こーえー,しんせん,せんりゃく,真戦,さんごくし,shinsen,sangokushi,三國,三国,三国志,三國志,真戦,光栄,三國志8,三國志覇道,三国覇王戦記,率土之滨,覇王の業,波乱の三国志クラッシュ・オブ・クラン,クラッシュ・オブ・キングス,Crusader Kings 3 ,エンパイア: トータル ウォー,AFK Arena,Lords Mobile,ラストウォー",
      },
      props: (route) => ({
        id: route.query.id,
        columnsId: route.query.columnsId,
      }),
    },
    // 404
    {
      path: "/:pathMatch(.*)*",
      component: () => import("../../components/404.vue"),
    },
    // 测试
    {
      path: "/test",
      component: () => import("./views/test.vue"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  ReviseMeta(to.meta.title, to.meta.keywords, to.meta.description);

  const specialPages = [
    /^\/down(\/.*)?$/,
    /^\/shop(\/.*)?$/,
    /^\/resume(\/.*)?$/,
  ];
  const isSpecialPage = specialPages.some((pattern) => pattern.test(to.path));

  if (isSpecialPage) {
    next();
    return;
  }

  const isWap = deviceType() == "wap";
  const pcPath = to.path.replace(/\/m$/, "");
  const wapPath = pcPath.endsWith("/") ? `${pcPath}m` : `${pcPath}/m`;

  if (isWap && !to.path.endsWith("/m")) {
    next({ path: wapPath, query: to.query });
  } else if (!isWap && to.path.endsWith("/m")) {
    next({ path: pcPath, query: to.query });
  } else {
    next();
  }
});

export default router;
